import AlertIcon from '@components/alerticon';
import Typography from '@components/typography';
import { VERIFY } from '@navigation/constants';
import { ModalContent } from 'interface';

export const verifyEmail = (search: string) => {
  const buttons = (
    <a
      href={VERIFY + encodeURIComponent(search)}
      className="modal-content__body-buttons-button modal-content__body-buttons-button--primary"
      data-testid="verify-email-verify-button"
    >
      <Typography
        variant="caption"
        size="rg"
        weight="semi-bold"
        colour="alternative"
      >
        Verify
      </Typography>
    </a>
  );

  return {
    icon: <AlertIcon />,
    title: 'Email needs verification',
    message: 'In order to place an order you must verify your email address.',
    buttons: buttons,
  } as ModalContent;
};
